import { ITransferExamTypeWithExams } from './../../queries/transfer_exam_type_with_exams_query';
import { ExamQueryResults } from './../../builders/exam_query_results_builder';
import { Exam } from './../../builders/exam_builder';
import { ICommand } from 'core-ts-types';
import { ExamType } from './../../builders/exam_type_builder';
import { MemberDatasource, IMemberDatasource } from './../../../global/datasources/member_datasource';
import * as _4 from 'lodash';
import { getSearchResultsMessage } from '../../../global/strategies/search_results_strategy';

export class TransferExamTypeTileController {
  querySet: {
    has_no_messages: boolean;
    has_more: boolean;
    result: Exam[];
  };

  searchExamNoResultsMsg: string;
  examTypeNamesRegEx: RegExp;

  model: {
    member: IMemberDatasource;
  };

  flags: {
    showExamSearch: boolean;
    isHovering: boolean;
  };

  private dropdownHeader: string = '';

  private examTypeWithExams: ITransferExamTypeWithExams;
  private onClose: (item: Object) => void;

  constructor(
    ngMemberDatasource: MemberDatasource,
    private searchTransferExamCommand: ICommand,
    private selectTransferExamCommand: ICommand,
    private updateTransferExamCommand: ICommand,
    private transferExamTileDelegate: any,
    private $timeout: ng.ITimeoutService,
    private $element: ng.IAugmentedJQuery
  ) {
    this.model = {
      member: ngMemberDatasource.read()
    };
  }

  $onInit() {
    const examType = this.examTypeWithExams.exam_type.title;
    this.examTypeNamesRegEx = new RegExp(`^(${examType}|${examType})\\s?`, 'i');
    this.flags = {
      showExamSearch: !(this.examTypeWithExams.exams.length === 0),
      isHovering: false
    };
  }

  onExitTab() {
    this.onClose({
      queryItem: this.examTypeWithExams.exam_type
    });
  }

  onQueryChange($event: any): void {
    const queryText = $event.detail.value;
    const examType: string = this.examTypeWithExams.exam_type.title;
    const calculatedQueryText = queryText.replace(this.examTypeNamesRegEx, '');
    this.searchTransferExamCommand(this.examTypeWithExams.exam_type.code, calculatedQueryText).then(
      (response: ExamQueryResults) => {
        this.querySet = {
          has_no_messages: false,
          has_more: response.has_more,
          result: response.exams
        };

        this.querySet.has_no_messages = !this.hasNoResults() && !this.hasManyResults();
        this.dropdownHeader = getSearchResultsMessage(this.querySet);
      }
    );
  }

  onEnter(): void {
    this.flags.isHovering = true;
  }

  onLeave(): void {
    this.flags.isHovering = false;
  }

  shouldShowExamDescription(): boolean {
    return this.flags.isHovering && !!this.examTypeWithExams.exam_type.about_text;
  }

  onSelectExam($event: any): void {
    const exam = $event.detail.item.__data.value;

    this.selectTransferExamCommand(exam).then(() => {
      this.$timeout(() => {
        this.$element.find(`#exam_typeahead${this.examTypeWithExams.exam_type.id}`)[0]['searchValue'] = '';
        this.transferExamTileDelegate.handle(exam.id).strobe();
      });
    });
  }

  hasManyResults() {
    return _4.get(this, 'querySet.has_more', false);
  }

  hasNoResults() {
    return _4.size(_4.get(this, 'querySet.result', [])) <= 0;
  }

  hasExams() {
    return !_.isEmpty(this.examTypeWithExams.exams);
  }

  enableExamSearch(): void {
    this.flags.showExamSearch = true;
    const angularReRenderingTime = 150;
    this.$timeout(() => {
      const elementFocusOn = this.$element.find(`#exam_typeahead${this.examTypeWithExams.exam_type.id}`)[0];
      if (!elementFocusOn) {
        return;
      }
      elementFocusOn.scrollIntoView({ behavior: 'smooth' });
      elementFocusOn.focus();
    }, angularReRenderingTime);
  }
}

angular
  .module('capability-ng-transfer')
  .controller('ngTransferExamTypeTileController', TransferExamTypeTileController)
  .component('transferExamTypeTile', {
    controller: 'ngTransferExamTypeTileController',
    templateUrl: 'lib/transfer/components/exam_type_tile/exam_type_tile.html',
    controllerAs: '$ctrl',
    bindings: {
      examTypeWithExams: '<',
      onClose: '&',
      isLast: '<'
    }
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/components/exam_type_tile/exam_type_tile.ts